<template>
  <div>
    <h5 v-if="![20, 22, 23, 24, 25].includes(type)">Options</h5>
    <h5 v-else>{{ $t("global.subitem_title") }}:</h5>
    <v-container fluid class="pa-0">
      <v-form ref="optionsList">
        <v-row v-for="(item, index) in list" :key="index">
          <v-col cols="12" md="3">
            <v-text-field
              v-model="item.label"
              outlined
              hide-details
              :label="$t('checklisttemplate.label')"
              required
              autocomplete="new-password"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3" v-if="![20, 22, 23, 24, 25].includes(type)">
            <v-text-field
              v-model="item.value"
              outlined
              hide-details
              :label="$t('checklisttemplate.value')"
              required
              autocomplete="new-password"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="1" key="mx-auto" v-if="list.length < 2">
            <v-checkbox v-if="![20, 22, 23, 24, 25].includes(type)" v-model="item.isactive" hide-details></v-checkbox>
          </v-col>
          <v-col cols="12" v-if="list.length > 1" :md="type === 18 ? 2 : 3">
            <v-layout>
              <v-btn class="mt-2" fab dark :small="type !== 18" :x-small="type === 18" color="error" @click="removeOption(index)">
                <v-icon dark>mdi-minus</v-icon>
              </v-btn>
              <v-checkbox v-if="![20, 22, 23, 24, 25].includes(type)" class="mx-3" v-model="item.isactive" hide-details></v-checkbox>
            </v-layout>
          </v-col>
          <!-- <v-col cols="12" md="3">
            <v-btn class="mt-2" fab dark small color="error" v-if="list.length > 1" @click="removeOption(index)">
              <v-icon dark>mdi-minus</v-icon>
            </v-btn>
          </v-col> -->
        </v-row>
        <v-btn class="mx-2" @click="addNewOption" fab dark small color="primary">
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
      </v-form>
    </v-container>
  </div>
</template>
<script>
export default {
  props: {
    list: Array,
    default: () => [],
    type: Number
  },
  methods: {
    addNewOption() {
      this.list.push({ isactive: true })
    },
    removeOption(index) {
      this.list.splice(index, 1)
    }
  }
}
</script>
